<template>
  
  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>patient zero</p>
    <div class='has-text-left'>
      <p>On March 20th, 2020 at 7:59 PM, reddit user <span class='userName'>{{ patient0 }}</span> got very sick. Over the next month, his illness would spread to <span class='myNumber'>{{ totNumInfected }}</span> r/memes users. Here's how it happened.</p>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        patient0: 'woodendoors7',
        totNumInfected: '126,852'
      }
    }
  }
</script>